import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import { CloseIcon } from "./icons";

class FileKeyRegistry {
  private readonly keys = new WeakMap<File, number>();
  private nextKey = 1;

  key(file: File): number {
    const existing = this.keys.get(file);
    if (existing !== undefined) return existing;
    const key = this.nextKey++;
    this.keys.set(file, key);
    return key;
  }
}

const fileKeys = new FileKeyRegistry();

interface Props {
  files: File[];
  onRemove: (index: number) => void;
}

export function FileChips({ files, onRemove }: Props) {
  const copy = useQuoteCopy();
  if (!files.length) return null;
  return (
    <div className="qf-file-preview">
      {files.map((f, i) => (
        <div className="qf-file-chip" key={fileKeys.key(f)}>
          <span title={f.name}>{f.name}</span>
          <button
            type="button"
            className="qf-file-remove"
            aria-label={copy.t("qf.removeFile", { name: f.name })}
            onClick={() => onRemove(i)}
          >
            <CloseIcon size={13} />
          </button>
        </div>
      ))}
    </div>
  );
}
